const customApiPath = '/application/api';
const getBaseUrl = (oneLni:any) => oneLni.environment.current.apiLocation.slice(0, -customApiPath.length);

export default async (context:any, payload:any) => {
    const baseUrl = getBaseUrl(payload.oneLni);
    const endpoint = `${baseUrl}/api/content/_search`;
    const body = {
        query: `+identifier:(${Object.values(payload.ids).join(' ')})`,
    };

    try {
        const response = await fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const result = await response.text();
        return JSON.parse(result).entity.jsonObjectView.contentlets;
    } catch (error) {
        // TODO: Error handling
        return error;
    }
};